// extracted by mini-css-extract-plugin
export default {"continue":"vl-z"};